export default __webpack_public_path__ + "static/media/DDA.bad3d1aa.png";